export default "__VITE_ASSET__CJ7vNsoO__"